<template>
  <div class="container">
    <div class="content">
      <p v-html="content"></p>
    </div>
  </div>
</template>

<script>
import request from "@/api/jobProgress";
export default {
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      const para = {
        zphdid: this.$route.query.id
      };
      const data = await request.getReportInfomation(para);
      console.log(data);
      this.content = data.ds[0].bdtznr;
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  background: #f7f9fa;
  .content {
    width: 70%;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    min-height: 500px;
  }
}
</style>
